export default __webpack_public_path__ + "static/media/Tick.32872a74.svg";